interface Config {
  domain: string
}

const config: Config = {
  domain: 'shoplink.auth0.com',
}

export default config